import { useEffect } from 'react';
import SupportChat from '@widgets/support-chat';

export const useSupportChat = (user: { id: number } | null, loading: boolean) => {
    const userId = loading ? undefined : (user?.id ?? null);

    useEffect(() => {
        if (userId !== undefined) SupportChat.start(userId);
    }, [userId]);
};
